module.exports = __webpack_public_path__ + "static/media/step-payments-icon.37b6ee7a.svg";